import * as IconSelector from '../icons';

export const tiposEmpresa = [
    {
        value: null,
        label: 'Sin definir',
        description: 'Sin tipo definido',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: 'Persona Fisica',
        label: 'Persona Fisica',
        description: 'Persona Fisica',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'Particular',
        label: 'Particular',
        description: 'Persona Fisica',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'Comunidad de bienes',
        label: 'Comunidad de bienes',
        description: 'Comunidad de bienes',
        icon: IconSelector.PointIcon,
        color: 'DarkGrey'
    },
    {
        value: 'Sociedad Limitada',
        label: 'Sociedad Limitada',
        description: 'Sociedad Limitada',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'Sociedad Anonima',
        label: 'Sociedad Anonima',
        description: 'Sociedad Anonima',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'SAT',
        label: 'SAT',
        description: 'Sociedad Agraria de Transformación',
        icon: IconSelector.PointIcon,
        color: 'DarkOrange'
    },
    {
        value: 'Cooperativa',
        label: 'Cooperativa',
        description: 'Cooperativa',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Coop Grado 1',
        label: 'Coop Grado 1',
        description: 'Cooperativa',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Sdad Mercantil',
        label: 'Sdad Mercantil',
        description: 'Sdad Mercantil',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Otros',
        label: 'Otros',
        description: 'Otros',
        icon: IconSelector.PointIcon,
        color: 'Green'
    }
];
